export default __webpack_public_path__ + "static/media/preloader.91239ecd.gif";